import React, { Component } from "react";
import styles from "./Item.local.scss";
import _ from "i18n";

class LegalFormsList extends Component {
  constructor(props) {
    super(props);
    this.state = { viewMoreLegalForms: false };
  }

  render() {
    let legalforms = this.props.legalForms;

    return (
      <div className={styles.row_groups_cell_wrapper}>
        {legalforms.map((item, i) => {
          return (
            <span className={styles.row_group_cell_tag}>
              {item ? item : _("noLegalForms")}{" "}
            </span>
          );
        })}
      </div>
    );
  }
}

export default LegalFormsList;



// WEBPACK FOOTER //
// ./src/components/DashboardList/LegalFormsList.js